const Evidence_PERMISSIONS = {
  Evidence_Record: 'Evidence Record',
  Evidence_Storage: 'Evidence Storage',
  Evidence_Custody: 'Evidence Custody',
  Evidence_Parties: 'Evidence Parties',
  Evidence_Attachments: 'Evidence Attachments',
  Evidence_Dispositions: 'Evidence Dispositions',
  Check_Out_Requests: 'Check Out Requests',
  Corrections: 'Corrections',
  Evidence_Audit: 'Evidence Audit',
  Print_Reports: 'Print Reports',
  Print_Labels: 'Print Labels',
  Edit_Items_Submitted_By_User: 'Edit Items Submitted by user (Custody & Party)',
  Check_Items_In_Out: 'Check Items In/Out',
  Manage_Disposal_Rules: 'Manage Disposal Rules',
  Access_Configuration: 'Access Configuration',
  Evidence:'Evidence',
};

export default Evidence_PERMISSIONS;
